export default __webpack_public_path__ + "f4fe8dd739f10bf7bd5003d7d6b0e6ba.png";